import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from "jquery";
import NumericCellDinamic from './NumericTextDinamic';
  var thisState;
  var optionsCapacidades = [];

class DropDownCellCor extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: null,
      datatav: null
    };
  }

  componentDidMount() {
    thisState = this;
    (async () => {
      optionsCapacidades = [];
      const data = {}
      const TipoVasilha = await services.apiCall.requestApi(
          "/Fiscalizacao/GetCores",
          data,
          "get"
      );
      
      console.log("CORESSSSS", TipoVasilha)
      TipoVasilha.map((tipo) => (
        optionsCapacidades.push({text: tipo.descor, value: tipo.idcor})
      ));

      this.setState({ datatav: 1 }); 
    })();
  }

  static changebyCorrelativa(value , dataItem){
    console.log(value)
    const matchedOption = optionsCapacidades.find(option => option.text === value.split(" - ")[3]);
    if (matchedOption) {
      console.log(thisState.props)
      dataItem["CapacidadeND"] = matchedOption;
      thisState.setState({ selectedValue: matchedOption.value });
      thisState.forceChange(matchedOption);
    }
  }

  forceChange = (value) => {
    const syntheticEvent = { target: { value } };
    this.handleChange(syntheticEvent);  // Chama handleChange com um evento simulado
  }

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });
    this.setState({ selectedValue: e.target.value });
  }

  render() {



    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';
    var indexId = dataItem.ProductID;
    if(dataItem.inEdit == true){
      indexId = 0
    }
    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    if(dataItem.idCor != undefined && dataItem.idCor != null && optionsCapacidades.length> 0){
      if(dataItem.idCor == 0){
        dataItem.idCor = 4
      }
      var dataEnter = optionsCapacidades.find(c => c.value === (dataItem.idCor))
    }

    return (
      <td>
        {dataItem.inEdit ? (
          <DropDownList
            popupSettings={{
              width: 'max-content',
            }}
            onChange={this.handleChange}
            value={optionsCapacidades.find(c => c.value === this.state.selectedValue) || dataValue}
            data={optionsCapacidades}
            textField="text"
            id='id-DropDownCellCapacidades'
          />
        ) : (


          dataValue != null && dataValue !== "" && dataValue !== undefined  ? dataValue.text.toString() : dataEnter != null ? dataEnter.text  : undefined
        )}
      </td>
    );
  }
    
}

export default DropDownCellCor;